import { StringUtil } from "@mcleod/core";
import { AutogenLayoutInboundFuncAck } from "./autogen/AutogenLayoutInboundFuncAck";
import { setQuickInfo } from "./DataFusionUtil";
import { DataSourceExecutionEvent, Layout } from "@mcleod/components";
import { EdiProfileGenericQuickInfo } from "./EdiProfileGenericQuickInfo";

export class InboundFuncAck extends AutogenLayoutInboundFuncAck {


  private async setQuickInfos() {
    const quickInfoMappings = [
      { field: "template_id", component: this.textboxAckTemplate, layout: "lme/datafusion/EdiTemplateQuickInfo" },
      { field: "edi_comm_id", component: this.textboxAckCommId, layout: "lme/datafusion/EdiCommControlQuickInfo" },
    ];

    quickInfoMappings.forEach(async ({ field, component, layout }) => {
      const value = this.mainDataSource?.activeRow?.get(field);
      if (value) {
        setQuickInfo(value, component, layout);
      }
    });
  }


  /** This is an event handler for the afterExecution event of sourceEdiProfile. */
  sourceEdiProfileAfterExecution(event: DataSourceExecutionEvent) {
    const modelRow = this.mainDataSource.activeRow;
    this.setQuickInfos();
    if (!StringUtil.isEmptyString(modelRow?.get("partner_id"))) {
      this.textboxAckPartnerName.tooltipDynamicContent = async () => {
        const layout = await Layout.getLoadedLayout("lme/datafusion/EdiProfileGenericQuickInfo") as EdiProfileGenericQuickInfo;
        await layout.sourceEdigenericProfile?.search({id: modelRow.get("id")});
        return layout;
      }
    }
  }
}
